import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  ResultsTitle: {
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "23px",
    textAlign: "center",
  },
}));

type CalculatorResultsTitleProps = {
  text?: string;
};

export const CalculatorResultsTitle: FC<CalculatorResultsTitleProps> = ({ text }) => {
  const classes = useStyles();
  return (
    <div style={{ textAlign: "center" }} className={classes.ResultsTitle}>
      {text}
    </div>
  )
}